import router from '@/router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { useAuthStore } from "@/stores/user-auth";
import { hasPermisson } from "@/stores/permission";


router.beforeEach(async (to) => {

  NProgress.start();
  
  const mainTitle = import.meta.env.VITE_BASE_NAME;

  document.title = mainTitle + ": " + to.meta?.title;
  
  const authStore = useAuthStore();

  // Allow ALL
  if (to.meta.permission == 'all') {
    return true;
  }
  // Проверяем права доступа
  if (await hasPermisson(to.meta.permission)) {
    return true;
  } else {
    if (authStore.isAuthenticated) {
      return '/';
    } else {
      return '/login';
    }
  }
  return '/';
})

router.afterEach(() => {
  NProgress.done();
})
